import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../enums/QueryKey';
import dayjs, { Dayjs } from '@utils/dayjs';
import { getCompletedCalculations } from '../../services/completedCalculation';
import { appTimezone } from '../../config';

export const getCompletedCalculationsQueryKey = (filterParams: {
    date: string | Date | Dayjs;
    workingUnitLocation: number;
}) => {
    const { date, workingUnitLocation } = filterParams;

    // Use app timezone since slots represent business times in Berlin
    const dateFrom = dayjs(date).tz(appTimezone).startOf('month').toISOString();
    const dateTo = dayjs(date).tz(appTimezone).endOf('month').toISOString();

    return [
        QueryKey.CompletedCalculations,
        {
            dateFrom,
            dateTo,
            workingUnitLocation,
        },
    ];
};

export function useCompletedCalculations({
    date,
    workingUnitLocation,
}: {
    date: string | Date | Dayjs;
    workingUnitLocation: number;
}) {
    // Use app timezone since slots represent business times in Berlin
    const dateFrom = dayjs(date).tz(appTimezone).startOf('month').toISOString();
    const dateTo = dayjs(date).tz(appTimezone).endOf('month').toISOString();

    const { data } = useQuery({
        queryKey: getCompletedCalculationsQueryKey({ date, workingUnitLocation }),
        queryFn: () => getCompletedCalculations({ dateFrom, dateTo, workingUnitLocation }),
        enabled: !!date,
        refetchOnWindowFocus: false,
    });

    return [data || []];
}
